import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { DragDropContext } from 'react-beautiful-dnd';
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import OurStore from "./pages/OurStore";
import Blog from "./pages/Blog";
import CompareProduct from "./pages/CompareProduct";
import Wishlist from "./pages/Wishlist";
import Login from "./pages/Login";
import Forgotpassword from "./pages/Forgotpassword";
import Signup from "./pages/Signup";
import Resetpassword from "./pages/Resetpassword";
import SingleBlog from "./pages/SingleBlog";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ShippingPolicy from "./pages/ShippingPolicy";
import TermAndContions from "./pages/TermAndContions";
import SingleProduct from "./pages/SingleProduct";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import CheckoutInstant from "./pages/CheckoutInstant";
import { PrivateRoutes } from "./routing/PrivateRoutes";
import { OpenRoutes } from "./routing/OpenRoutes";
import Orders from "./pages/Orders";
import Profile from "./pages/Profile";
import CancellationPolicy from "./pages/CancellationPolicy";
import Videos from "./pages/Videos";
import Puzzle from "./pages/Puzzles";
import Games from "./pages/Games";
import VirtualTemples from "./pages/VirtualTemples";
import RamMandir from "./pages/RamMandir";
import KedarnathTemple from "./pages/KedarnathTemple";
import Unsubscribe from "./pages/Unsubscribe";
import VerifyEmail from "./pages/VerifyEmail";
import ResendVerification from "./pages/ResendVerification";
import TrackOrder from "./pages/TrackOrder";
import GoogleAuthSuccess from "./pages/GoogleAuthSuccess";

// Import i18n
import './utils/i18n';

// Import LanguageProvider
import { LanguageProvider } from "./contexts/LanguageContext";

// Import ScrollToTop component
import ScrollToTop from "./components/ScrollToTop";

// Import Meta Pixel tracking
import { trackPageView } from './utils/metaPixel';

// Dummy function for drag and drop context
const onDragEnd = (result) => {
  // This is a dummy function as each component will handle its own drag and drop
  return result;
};

// Component to track route changes
function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    trackPageView();
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <>
      <Router>
        <LanguageProvider>
          <ScrollToTop />
          <RouteTracker />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="about" element={<About />} />
              <Route path="contact" element={<Contact />} />
              <Route path="product" element={<OurStore />} />
              <Route path="products" element={<OurStore />} />
              <Route path="videos" element={<Videos />} />
              <Route path="puzzles" element={<Puzzle />} />
              <Route path="games" element={<Games />} />
              <Route path="virtual-temples" element={<VirtualTemples />} />
              {/* SEO-friendly route for Ram Mandir */}
              <Route path="ram-mandir" element={<RamMandir />} />
              {/* SEO-friendly route for Kedarnath Temple */}
              <Route path="kedarnath-temple" element={<KedarnathTemple />} />
              <Route path="product/:id" element={<SingleProduct />} />
              <Route path="blogs" element={<Blog />} />
              <Route path="blog/:id" element={<SingleBlog />} />
              <Route
                path="cart"
                element={
                  <Cart />
                }
              />
              <Route
                path="my-orders"
                element={
                  <Orders />
                }
              />
              <Route
                path="track-order/:orderId"
                element={
                  <TrackOrder />
                }
              />
              <Route
                path="my-profile"
                element={
                  <PrivateRoutes>
                    <Profile />
                  </PrivateRoutes>
                }
              />
              <Route
                path="checkout"
                element={
                  <Checkout />
                }
              />
              {/* New route for instant checkout with product ID */}
              <Route
                path="checkout/:productId"
                element={
                  <CheckoutInstant/>
                }
              />
              <Route path="compare-product" element={<CompareProduct />} />
              <Route
                path="wishlist"
                element={
                  <Wishlist />
                }
              />
              <Route
                path="login"
                element={
                  <OpenRoutes>
                    <Login />
                  </OpenRoutes>
                }
              />
              <Route path="forgot-password" element={<Forgotpassword />} />
              <Route
                path="signup"
                element={
                  <OpenRoutes>
                    <Signup />
                  </OpenRoutes>
                }
              />
              <Route path="reset-password/:token" element={<Resetpassword />} />
              <Route path="privacy-policy" element={<PrivacyPolicy />} />
              <Route path="shipping-delivery-policy" element={<ShippingPolicy />} />
              <Route path="terms-and-conditions-policy" element={<TermAndContions />} />
              <Route path="cancellation-refund-policy" element={<CancellationPolicy />} />
              <Route path="/unsubscribe" element={<Unsubscribe />} />
              <Route path="verify-email/:token" element={<VerifyEmail />} />
              <Route path="resend-verification" element={<ResendVerification />} />
              <Route path="google-auth-success" element={<GoogleAuthSuccess />} />
            </Route>
          </Routes>
        </LanguageProvider>
      </Router>
    </>
  );
}

export default App;